import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import React, { useEffect, useState } from "react";
import Headline5 from "../../components/headings/Headline5";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import { EditorState, convertToRaw } from "draft-js";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import { getMilliSecUTC } from "../../utils/EllowUtils";
import { DropDownInput } from "../../wrappers/selectInput";

export type RequestRatingForm = {
  email: string;
  companyName: string;
  designation: string;
  contractDuration: any;
  emailBody: string;
};

interface Props {
  onClose?: any;
  clickHandler?: any;
  companyNames?: any;
  fetchJobDetails?: any;
  defaultValues?: any;
}

const validationSchema = Yup.object({
  email: Yup.string().required("Field is required").email('Please provide a valid Work Email'),
  companyName: Yup.object().required("Field is required").nullable(),
  designation: Yup.string().required("Field is required"),
});

const RequestRating: React.FC<Props> = ({ onClose, clickHandler, companyNames, fetchJobDetails, defaultValues }) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState
  } = useForm<RequestRatingForm>(formOptions);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    setValue("emailBody", JSON.stringify(convertToRaw(contentState)));
  };

  useEffect(() => {
    
    if (watch().companyName) {
      fetchJobDetails(watch().companyName)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().companyName])
  
  useEffect(() => {
    if (defaultValues) {
      setValue('designation', defaultValues.designation)
      setValue('email', defaultValues.email)
      setValue('emailBody', defaultValues.emailBody)
    
      let date = {
        from: getMilliSecUTC(defaultValues.contractDuration.start),
        to: getMilliSecUTC(defaultValues.contractDuration.start)
            }
      setValue("contractDuration", date);
    }
      }
     
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ,[defaultValues])

  const onSubmit = (data: any) => {

    let value = {
      email: data.email,
      companyName: data.companyName,
      designation: data.designation,
      emailBody: data.emailBody,
      contractDuration: watch().contractDuration,
    };
    clickHandler(value)
  };

  const handleChange = (e: any) => {
    if (e.value.start && e.value.end) {
      let date = {
        from: getMilliSecUTC(e.value.start),
        to: getMilliSecUTC(e.value.end)
            }
      setValue("contractDuration", date);
    }
  };


  return (
    <Modal title={"Request Rating"} size="medium" onClose={onClose}>
      <form>
        <Headline5>Request Rating</Headline5>
        <div className="form-group">
          <DropDownInput<RequestRatingForm>
            name="companyName"
            label="Company Name"
            register={register}
            errors={formState.errors}
            control={control}
            data={companyNames}
            dataItemKey='companyId'
            textField='companyName'
          />
        </div>
        <div className="form-group">
          <FormInput<RequestRatingForm>
            name="email"
            label="Email"
            placeholder="Please enter the reporting manager email id"
            register={register}
            type="text"
            errors={formState.errors}
          />
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<RequestRatingForm>
              name="designation"
              label="Candidate Designation"
              placeholder="Enter Candidate designation"
              register={register}
              type="text"
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Contract duration</label>
            <div className="datePicker noLabel">
              <DateRangePicker onChange={handleChange} defaultValue={defaultValues && defaultValues.contractDuration} />
            </div>
          </div>
        </div>
        {/* <div className="form-group">
          <label className="lablel">Email body</label>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
          />
        </div> */}

        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={false}
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default RequestRating;
